// extracted by mini-css-extract-plugin
module.exports = {"title-container":"TitleContainer_title-container__1nEKY"};